import React from 'react';

import { InterventionForm } from 'components';

export const PageInterventionInspection = () => (
  <InterventionForm />
);
